module.exports = {"component":"filter","status":"prototype","display-name":"Filters","SLDS-component-path":"/components/filter","url-slug":"filters"}


//////////////////
// WEBPACK FOOTER
// ./components/filter/docs.json
// module id = 251
// module chunks = 0